/* Choisir la Page Facebook — DS-09 (Bible §18).
   Signing in with Facebook (customer identity) and connecting a Page
   (a Destination) are two different things; one never authorises the other.
   A Page that has Recommendations off is not eligible — stated, not hidden. */
import { useState } from 'react'
import { Button, EmptyState, ErrorState, ListRow, Note } from '@/ui'
import { useFacebookPages } from './api'
import { Chargement, Retour } from './parts'

export default function Facebook() {
  const { data, isPending, isError, refetch } = useFacebookPages()
  const [choisie, setChoisie] = useState('p1')

  if (isPending) return <Chargement />
  if (isError) return (
    <ErrorState what="Impossible de charger vos Pages Facebook."
      action={<Button variant="primary" size="sm" onClick={() => refetch()}>Réessayer</Button>} />
  )

  return (
    <div style={{ display: 'grid', gap: 16, maxWidth: 660 }}>
      <Retour />
      <h2 className="t-page" style={{ margin: 0 }}>Choisir la Page Facebook</h2>

      {data.length === 0 ? (
        <EmptyState title="Aucune Page à connecter."
          why="Connectez un compte Facebook disposant d’une Page pour choisir où atterrissent les recommandations." />
      ) : (
        <section>
          {data.map(p => (
            <ListRow key={p.id} title={p.name} meta={p.meta}
              end={p.eligible
                ? <input type="radio" name="page" className="chk" style={{ borderRadius: '50%' }}
                    checked={choisie === p.id} onChange={() => setChoisie(p.id)}
                    aria-label={`Choisir ${p.name}`} />
                : <span className="pill pill-done">indisponible</span>} />
          ))}
        </section>
      )}

      <Note tone="candour">
        Se connecter avec Facebook (identité client) et connecter une Page (lien d’avis)
        sont deux choses distinctes&nbsp;: l’une n’autorise jamais l’autre. Nous ne
        revendiquons ni flux de notes ni partenariat.
      </Note>
    </div>
  )
}
